import React from "react";
import PropTypes from "prop-types";

import Loader from "shared-anpost-components/components/loader/Loader";

// styles
import BlankScreenStyled from "./blankScreen.styled";

const BlankScreen = ({ fullPage = false }) => {
    return (
        <BlankScreenStyled $fullPage={fullPage}>
            <Loader local />
        </BlankScreenStyled>
    );
};

export default BlankScreen;

BlankScreen.propTypes = {
    fullPage: PropTypes.bool
};
